import styled from "styled-components/macro";

export const maxWidthRootPages = "50rem";

export const MainSide = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-area: 1/2;
  justify-items: center;
  transition: 0.5s;
  & section {
    max-width: 512px;
  }
  & .buttonGroup {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    width: 100%;
    & button {
      margin: 16px 0 0 24px;
    }
  }
  & .button-group {
    @media ${(props) => props.theme.media.phone} {
      flex-direction: column;

      & button {
        width: 100%;
        margin: 0 0 8px 0;
      }
      & div {
        flex-direction: column;
        width: 100%;
      }
    }
  }
  @media ${(props) => props.theme.media.leftmenu} {
    grid-area: initial;
    & .buttonGroup {
      flex-direction: column;
      & button {
        width: 100% !important;
        margin: 16px 0 0 0;
      }
    }
  }
  @media (max-width: 650px) {
    & section {
      width: calc(100% - 128px);
    }
  }
  @media ${(props) => props.theme.media.phone} {
    & section {
      width: calc(100% - 32px);
    }
  }
`;


export const LimitWidthSection = styled.section`
  max-width: ${maxWidthRootPages};
  width: 100%;
`;